import { useI18n } from '../../contexts/I18nContext';
import type { LeadPipeline } from '../../lib/leadsApi';

/**
 * One tab per pipeline on the Pipeline page (Vânzări | Onboarding | …), in the
 * order the API returns them (the default one first). Replaces the old
 * pipeline dropdown: every pipeline is one click away. Scrolls sideways on a
 * phone when there are many.
 */
export function PipelineTabs({
  pipelines,
  activeId,
  onChange,
}: {
  pipelines: LeadPipeline[];
  activeId: string | undefined;
  onChange: (id: string) => void;
}) {
  const { t } = useI18n();
  if (pipelines.length === 0) return null;
  return (
    <div className="-mx-1 overflow-x-auto px-1">
      <div
        role="tablist"
        aria-label={t('leads.tabs')}
        className="inline-flex rounded-md border border-gray-200 bg-gray-50 p-0.5"
      >
        {pipelines.map((p) => {
          const active = p.id === activeId;
          return (
            <button
              key={p.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(p.id)}
              className={
                active
                  ? 'whitespace-nowrap rounded bg-white px-3 py-1.5 text-sm font-medium text-brand-700 shadow-sm'
                  : 'whitespace-nowrap rounded px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900'
              }
            >
              {p.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
